module.exports = __webpack_public_path__ + "static/media/banner-2-Mobile-En-1.41a917d2.jpg";